import { CURRENCIES, Money, type Currency } from '@chukua/common';
import { Form, InputNumber, Select } from 'antd';

const CURRENCY_OPTIONS = CURRENCIES.map((currency) => ({ value: currency, label: currency }));

interface AmountFieldsProps {
  label?: string;
  /** A price change keeps the line's currency; only a new line chooses one. */
  isCurrencyLocked?: boolean;
}

/** A price and its currency, the amount held to the currency's own decimal places. Form fields `amount` and `currency`. */
export function AmountFields({ label = 'Price', isCurrencyLocked = false }: AmountFieldsProps) {
  const currency = Form.useWatch<Currency | undefined>('currency') ?? 'KES';

  return (
    <div className="grid grid-cols-[1fr_auto] gap-3">
      <Form.Item name="amount" label={label} rules={[{ required: true, message: 'Enter a price' }]}>
        <InputNumber className="w-full" min={0} precision={Money.decimalPlaces(currency)} />
      </Form.Item>
      <Form.Item name="currency" label="Currency" rules={[{ required: true }]}>
        <Select className="w-24" disabled={isCurrencyLocked} options={CURRENCY_OPTIONS} />
      </Form.Item>
    </div>
  );
}
